import { mergeScreenState } from "@js/helpers/state.js";
import {
  CE_SET_BEE_UID,
  CE_SET_BEE_TOKEN_FAILURE,
} from "@js/actions/studio/campaign_content_section/set_bee_uid.js";

export default (state = {}, action) => {
  switch (action.type) {
    case CE_SET_BEE_UID:
      return mergeScreenState(state, {
        bee_uid: action.bee_uid,
        bee_token_error: false,
      });
    case CE_SET_BEE_TOKEN_FAILURE:
      return mergeScreenState(state, {
        bee_token_error: true,
      });
    default:
      return state;
  }
};
